export const CHATS_ROUTE = '/chats';

export const NOT_FOUND_ROUTE = '/error/404';

export const JOB_APPLICANTS_ROUTE = '/listings/my-listings/job-applicants';

export const MY_LISTINGS_ROUTE = '/listings/my-listings';

export const LISTING_VIEW_ROUTE = '/listings/my-listings/listing-view';

export const LISTING_STATS_ROUTE = '/listings/my-listings/listing-stats';

export const LISTING_LEADS_ROUTE = '/listings/my-listings/listing-leads';

export const APPLICANT_CV_ROUTE = '/listings/my-listings/ApplicantCVFullView';

export const LISTING_CHATS_STATE_TYPE = 'LISTING_CHATS';

export const PROMOTE_VAS_TYPES = ['Turbo', 'Premium', 'Bumpup'];

export const IMAGE_SIZE_TOKEN = '{size}';

export const APPLICANT_AVATAR_SIZE = '1024x0';

export const APPLICANT_DEFAULT_AVATAR =
  'https://opensooqui-new.s3.amazonaws.com/api/v/icons/misc/profile_avatar.png';

export const FAVORITE_ADDED_STATUSES = [200, 201];

export const FAVORITE_REMOVED_STATUS = 202;

export const FAVORITE_HEART = 'tw-text-[#ee5555]';

export const UNFAVORITE_HEART = 'tw-text-[#F1416C]';

export const SEARCH_ACTION_ICONS = {
  delete: 'https://opensooqui-new.s3.amazonaws.com/os_web/myopensooq/delete.png',
  notifications: '/media/img/bell.png',
  rename: '/media/img/pen.png',
  share: 'https://opensooqui-new.s3.amazonaws.com/os_web/myopensooq/share.png',
};

export const SECTION_CARD = 'tw-rounded-xl tw-bg-white tw-shadow-sm';

export const SECTION_TITLE = 'tw-m-0 tw-text-lg tw-font-bold tw-text-slate-900';

export const SECTION_SUBTITLE = 'tw-text-sm tw-text-slate-400';

export const MASKED_PHONE = 'XX';
